import { MenuItem } from "@mui/material";
import ActionConfirmDialog from "components/ActionConfirmDialog/ActionConfirmDialog";
import { Opportunity, OpportunityStatus } from "generated/graphql";
import useCancelOpportunity from "hooks/opportunities/useCancelOpportunity";
import useConfirmationDialog from "hooks/useConfirmationDialog";
import { useCallback } from "react";

export default function CancelOpportunityMenuItem(props: BitumioMenuItem<Opportunity>) {
  const { closeMenu, object } = props;
  const [cancelOpportunity, { isSuccess }] = useCancelOpportunity();

  const acceptFn = useCallback(async (): Promise<boolean> => {
    const { data } = await cancelOpportunity({ variables: { id: object.id } });
    if (isSuccess(data)) {
      closeMenu();
      return true;
    } else {
      return false;
    }
  }, []);

  const cancelFn = useCallback(async () => {
    closeMenu();
    return true;
  }, []);

  const { open, setOpen, onAccept, onCancel } = useConfirmationDialog({
    acceptFn,
    cancelFn,
  });

  if (props.object.status === OpportunityStatus.CANCELED) {
    return null;
  }

  return (
    <>
      <ActionConfirmDialog
        open={open}
        setOpen={setOpen}
        handleAccept={onAccept}
        handleCancel={onCancel}
        title="Are you sure you want to continue?"
        content="This opportunity will be cancelled. Are you sure you want to continue?"
        acceptText="Cancel Opportunity"
      />
      <MenuItem onClick={() => setOpen(true)}>Cancel</MenuItem>
    </>
  );
}
